import { render, staticRenderFns } from "./LogOpt.vue?vue&type=template&id=c452b442&scoped=true&"
import script from "./LogOpt.vue?vue&type=script&lang=js&"
export * from "./LogOpt.vue?vue&type=script&lang=js&"
import style0 from "./LogOpt.vue?vue&type=style&index=0&id=c452b442&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c452b442",
  null
  
)

export default component.exports